import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { PRODUCT_TYPE_MOVIE_REWARDS } from "@config/config";
import { ApplicationContext } from "@context/ApplicationContext";
import { SearchContext } from "@context/SearchContext";
import LinkTabs from "@components/LinkTabs";
import VenueInformation from "@components/V3/VenueDetails/VenueInformation";
import VenueSessionSelector from "@components/V3/VenueDetails/VenueSessionSelector";
import VenueTitleCard from "@components/V3/VenueDetails/VenueTitleCard";
import "./style.scss";

const VenueDetailsBase = () => {
    const { id, venue_name } = useParams();
    const { fetchVenue, fetchVenueSessions } = useContext(SearchContext);
    const { productTypeId } = useContext(ApplicationContext);
    const ismovieRewardsSite = productTypeId === PRODUCT_TYPE_MOVIE_REWARDS;

    useEffect(() => {
        if (id && venue_name) {
            fetchVenue(id, venue_name);
            fetchVenueSessions({ venueId: id });
        }
    }, [id, venue_name]);

    return (
        <>
            <VenueTitleCard />

            <div className="search-details-venue__content">
                <LinkTabs>
                    {ismovieRewardsSite && (
                        <div label="Sessions">
                            <VenueSessionSelector />
                        </div>
                    )}
                    <div label="About">
                        <VenueInformation />
                    </div>
                </LinkTabs>
            </div>
        </>

    );
};

export default VenueDetailsBase;
